import { AffiliateApi } from "@/api/affiliates";
import { UpdateAffiliatePaymentSettingsRequest } from "@/api/affiliates/types";
import { useUIStore } from "@/stores";
import { Referral } from "@/types";
import { QueryKey } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useUpdateAffiliatePaymentSettings = ({
  referralId,
}: {
  referralId?: Referral["id"];
} = {}) => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { closeModal } = useUIStore();

  const { mutate: updateAffiliatePaymentSettings, isPending } = useMutation({
    mutationFn: (body: UpdateAffiliatePaymentSettingsRequest) =>
      AffiliateApi.updateAffiliatePaymentSettings(body),
    onError: (error) => {
      setTimeout(() => {
        notify(error, { type: "error" });
      }, 250);
    },
    onSuccess: async (_, { affiliateId }) => {
      closeModal();

      if (referralId) {
        queryClient.invalidateQueries({
          queryKey: [QueryKey.REFERRAL_USER, referralId],
        });
      }
      queryClient.invalidateQueries({
        queryKey: [QueryKey.AFFILIATE_USER, affiliateId],
      });

      setTimeout(() => {
        notify("Updated!", { type: "success" });
      }, 250);
    },
  });

  return {
    updateAffiliatePaymentSettings,
    isUpdateAffiliatePaymentSettingsLoading: isPending,
  };
};
